import itly from 'itly';
import { ComponentName } from 'constants/componentName';

export const getLoadingComponentNames = (
  isVirtualCart: boolean,
  components: ComponentName[],
  isCheckout: boolean
): ComponentName[] => {
  if (!isVirtualCart && isCheckout) {
    components.push(ComponentName.SHIPPING_ADDRESS, ComponentName.SHIPPING_OPTIONS);
  }
  return components;
};

type UploadImageReportingProps = {
  acceptedFiles: any[];
  fileRejections: any[];
  isMobile: boolean;
  upload_source: string;
};

export const getExtension = (fileName: string): string => {
  const re = /(?:\.([^.]+))?$/;
  return re.exec(fileName)?.[1] || '<unknown>';
};

const DEVICE = 'device';

export const reportImageUploadsAttempt = ({
  acceptedFiles,
  fileRejections,
  isMobile,
  upload_source
}: UploadImageReportingProps): void => {
  const rejectedFiles = fileRejections.map(({ file }) => file);
  const allAttemptedFiles = [...acceptedFiles, ...rejectedFiles];

  itly.imageUploadAttempted({
    source: DEVICE,
    upload_source,
    is_mobile_view: isMobile, // should always be true because users get here with QR code
    upload_selected_extensions: String(allAttemptedFiles.map(file => getExtension(file.name)).join(', ')),
    upload_selected_count: String(allAttemptedFiles.length),
    upload_selected_sizes: allAttemptedFiles.map(file => file.size).join(', ')
  });
};

export const reportImageUploadsComplete = (upload_source: string): void => {
  itly.imageUploadCompleted({
    source: DEVICE,
    upload_completed_count: window.upload.uploadAttemptedCount,
    upload_completed_time: Date.now() - window.upload.uploadStartTime,
    upload_source,
    upload_completed_sizes: window.upload.uploadAttemptedSizes,
    upload_completed_extensions: window.upload.uploadAttemptedExtensions
  });

  window.upload = undefined; // Clear the upload object after completion
};

export const reportImageUploadsFailure = ({
  acceptedFiles,
  fileRejections,
  isMobile,
  upload_source
}: UploadImageReportingProps): void => {
  const uploadAcceptedCount = String(acceptedFiles.length);
  const uploadAcceptedSizes = acceptedFiles.map(file => file.size).join(', ');
  const uploadRejectedCount = String(fileRejections.length);
  const uploadRejectedSizes = fileRejections.map(({ file }) => file.size).join(', ');
  const uploadRejectedErrorCodes = fileRejections.map(({ errors }) => errors.map(({ code }) => code)).join(', ');

  itly.imageUploadFailed({
    is_mobile_view: isMobile,
    source: DEVICE,
    upload_source,
    upload_accepted_count: uploadAcceptedCount,
    upload_accepted_sizes: uploadAcceptedSizes,
    upload_rejected_count: uploadRejectedCount,
    upload_rejected_error_codes: uploadRejectedErrorCodes,
    upload_rejected_extensions: fileRejections.map(({ file }) => getExtension(file.name)).join(', '),
    upload_rejected_sizes: uploadRejectedSizes
  });
};
